import React from "react";
import styles from "./ResultCount.module.scss";

const ResultCount = (props) => {
    const { count } = props;
    const resultString = `Viser ${count} resultater.`;
    return (
        <div className={styles.container}>
            <p>{resultString}</p>
        </div>
    );
};

export default ResultCount;
